/*
 *
 * PatientOverviewPage constants
 *
 */
import { getPractice } from "utils/practiceStorage";

export const DEFAULT_ACTION = "app/PatientOverviewPage/DEFAULT_ACTION";

export const GET_PAGINATION_RESULTS_ACTION =
  "app/PatientOverviewPage/GET_PAGINATION_RESULTS_ACTION";
export const GET_PAGINATION_RESULTS_SUCCESS_ACTION =
  "app/PatientOverviewPage/GET_PAGINATION_RESULTS_SUCCESS_ACTION";
export const GET_PAGINATION_RESULTS_FAILED_ACTION =
  "app/PatientOverviewPage/GET_PAGINATION_RESULTS_SUCCESS_ACTION";

export function PAGINATION_URL() {
  return `/practices/${getPractice().id}/patients/pagination/filter`;
}
